import { Text as ChakraText } from '@chakra-ui/react';

const VText = ({ children, ...props }) => <ChakraText {...props}>{children}</ChakraText>;

export default VText;
